module.exports = __webpack_public_path__ + "static/media/title_marquee.798a73b0.jpg";